import { useMediaQuery, useTheme } from '@mui/material';
import { DesktopLayout } from '@/layouts/DesktopLayout';
import { MobileLayout } from '@/layouts/MobileLayout';

export function ResponsiveLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return isDesktop ? (
    <DesktopLayout />
  ) : (
    <MobileLayout />
  );
}
